import React, { Component } from "react";
import "./NodeManager.css";
import "./NetworkInfo.css";
import "./Dashboard.css";
import UserAddModal from "./UserAddModal";
import OrganizationAddModal from "./OrganizationAddModal";
import RemoveModal from "./RemoveModal";
import UserAdminModal from "./UserAdminModal";
import axios from "axios";
import { UserTable } from "./UserTable";
import { OrganizationTable } from "./OrganizationTable";
import { withRouter } from "react-router";
import "react-notifications-component/dist/theme.css";
import { store } from "react-notifications-component";
import "animate.css";
import EditIcon from "@material-ui/icons/Edit";
import { Form, FormGroup, Input } from "reactstrap";

class NetworkInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      view_mode: "users",
      validationErrors: [],
      network: {},
      loaded: false,
      selectedUsers: [],
      selectedOrganizations: [],
      userAddModal: false,
      userDeleteModal: false,
      userAdminModal: false,
      organizationAddModal: false,
      organizationRemoveModal: false,
      descriptionEditToggle: false,
      edit_description: "",
      removeUser: {
        header: "",
        body: "",
        button: "",
      },
    };
    this.newNode = React.createRef();
    this.newConfig = React.createRef();
    this.selectedRows = [];
  }

  isAdmin(user) {
    let admins = this.state.network.admins;
    return admins.includes(user);
  }

  setUser = (users) => {
    this.setState({ selectedUsers: users });
  };

  setOrganization = (organizations) => {
    this.setState({ selectedOrganizations: organizations });
  };

  componentDidMount() {
    this.refreshList();
  }

  getHeaders = () => {
    return {
      Authorization: `Token ${this.props.token}`,
      "Content-Type":
        "multipart/form-data; boundary=<calculated when request is sent></calculated>",
    };
  };

  downloadTxtFile = () => {
    const element = document.createElement("a");
    const file = new Blob([this.state.config.config_file], {
      type: "text/plain",
    });
    element.href = URL.createObjectURL(file);
    element.download = "host.txt";
    document.body.appendChild(element); // Required for this to work in FireFox
    element.click();
  };

  refreshList = () => {
    const networkUUID = this.props.match.params.networkUUID;

    axios
      .get(
        this.props.baseUrl + "/api/api/network/" + networkUUID + "/by_uuid",
        {
          headers: this.getHeaders(),
        }
      )
      .then((res) => {
        this.setState({ network: res.data });
        this.setState({ loaded: true });
        this.setState({ nodeList: this.state.network.nodes });
      })
      .catch((err) => {});
  };

  renderErrors = () => {
    const validationErrors = this.state.validationErrors;
    const error_tags = ["user", "organization"];
    let errors = [];

    for (var i = 0; i < error_tags.length; i++) {
      let error_msg = validationErrors[error_tags[i]];
      if (error_msg) {
        errors.push(<li key={error_tags[i]}>{error_msg}</li>);
      }
    }

    return errors;
  };

  toggleModal = (toggle) => {
    if (this.state[toggle]) {
      this.setState({ validationErrors: [] });
    }

    this.setState({ [toggle]: !this.state[toggle] });
  };

  handleDescriptionChange = (e) => {
    let description = e.target.value;
    this.setState({ edit_description: description });
  };

  editDescription = () => {
    const formData = new FormData();
    formData.append("description", this.state.edit_description);
    formData.append("_method", "PATCH");

    axios
      .patch(
        this.props.baseUrl +
          "/api/api/network/" +
          this.state.network.uuid +
          "/description/",
        formData,
        {
          headers: this.getHeaders(),
        }
      )
      .then((response) => {
        this.refreshList();
        this.setState({ validationErrors: [] });
        this.toggleModal("descriptionEditToggle");
      })
      .catch((errors) => {
        this.setState({ validationErrors: errors.response.data });
      });
    return;
  };

  addUser = async (userEmail) => {
    const formData = new FormData();
    formData.append("add-users", userEmail);
    formData.append("_method", "PATCH");
    let valid = true;

    axios
      .patch(
        this.props.baseUrl +
          "/api/api/network/" +
          this.state.network.uuid +
          "/users/",
        formData,
        {
          headers: this.getHeaders(),
        }
      )
      .then((response) => {
        this.refreshList();
        this.notify_add();
        this.setState({ validationErrors: [] });
        this.toggleModal("userAddModal");
      })
      .catch((errors) => {
        this.setState({ validationErrors: errors.response.data });
        valid = false;
      });
    return valid;
  };

  getUserStr = (selections, type) => {
    var i;
    var userStr = "";
    for (i = 0; i < selections.length; i++) {
      if (i === selections.length - 1 && i !== 0) {
        userStr += ", and ";
      } else if (i !== 0) {
        userStr += ", ";
      }
      if (type === "users") {
        userStr += selections[i].username;
      } else if (type === "organizations") {
        userStr += selections[i].name;
      }
    }
    return userStr;
  };

  addOrganization = (organizationUUID) => {
    const formData = new FormData();
    formData.append("add-organizations", organizationUUID);
    formData.append("_method", "PATCH");

    axios
      .patch(
        this.props.baseUrl +
          "/api/api/network/" +
          this.state.network.uuid +
          "/organizations/",
        formData,
        {
          headers: this.getHeaders(),
        }
      )
      .then((response) => {
        this.refreshList();
        this.notify_org_add();
        this.setState({ validationErrors: [] });
        this.toggleModal("organizationAddModal");
      })
      .catch((errors) => {
        this.setState({ validationErrors: errors.response.data });
      });
    return;
  };

  removeUserToggle = () => {
    var removeUser = { ...this.state.removeUser };

    let removedAdmins = 0;
    this.state.selectedUsers.forEach((user) => {
      if (this.isAdmin(user.username)) {
        removedAdmins += 1;
      }
    });
    if(this.state.network.users.length === this.state.selectedUsers.length){
      removeUser.body = (
        <>This would remove all remaining users.<br/><b>Confirming this action will delete any remaining nodes and remove the network permanently.</b></>
      );
      removeUser.header = "Remove users";
      removeUser.button = "Remove users and delete network";
    }
    else if (this.state.network.admins.length === removedAdmins) {
      removeUser.body = (
        <>This action would leave the network without admins.<br/> <b>Please grant admin rights to at least one other user to complete this action.</b></>
      );
      removeUser.header = "Cannot remove user";
      removeUser.button = "";
    } else {
      removeUser.body = (
        <>
          {"Are you sure you want to remove user" +
            (this.state.selectedUsers.length > 1 ? "s" : "") +
            " "}
          <b>{this.getUserStr(this.state.selectedUsers, "users")}</b>
          {"?"}
          <div style={{ marginTop: "10px" }} />
          {
            "If they have any nodes in the network, these will be permanently deleted."
          }
        </>
      );
      removeUser.header = "Remove User";
      removeUser.button = "Remove";
    }

    this.setState({ removeUser });
    this.setState({ userDeleteModal: true });
  };

  removeUser = () => {
    const formData = new FormData();
    let thisUserRemoved = false;

    this.state.selectedUsers.forEach((user) => {
      if (user.username === this.props.user) {
        thisUserRemoved = true;
      }
      formData.append("remove-users", user.email);
    });
    formData.append("_method", "PATCH");

    axios
      .patch(
        this.props.baseUrl +
          "/api/api/network/" +
          this.state.network.uuid +
          "/users/",
        formData,
        {
          headers: this.getHeaders(),
        }
      )
      .then((response) => {
        if (thisUserRemoved) {
          window.location = "/networks/";
          return;
        } else {
          this.refreshList();
          this.notify_delete();
          this.setState({ validationErrors: [] });
          this.toggleModal("userDeleteModal");
        }
      })
      .catch((errors) => {
        this.setState({ validationErrors: errors.response.data });
      });
    return;
  };

  removeOrganization = () => {
    const formData = new FormData();
    this.state.selectedOrganizations.forEach((organization) => {
      formData.append("remove-organizations", organization.name);
    });
    formData.append("_method", "PATCH");

    axios
      .patch(
        this.props.baseUrl +
          "/api/api/network/" +
          this.state.network.uuid +
          "/organizations/",
        formData,
        {
          headers: this.getHeaders(),
        }
      )
      .then((response) => {
        this.refreshList();
        this.notify_org_delete();
        this.setState({ validationErrors: [] });
        this.toggleModal("organizationRemoveModal");
      })
      .catch((errors) => {
        this.setState({ validationErrors: errors.response.data });
      });
    return;
  };

  editAdminToggle = () => {

    var removeUser = { ...this.state.removeUser };

    let selectedUser = this.state.selectedUsers[0];

    if(this.isAdmin(selectedUser.username) && this.state.network.admins.length === 1){
      removeUser.body = (
        <>This action would leave the network without admins.<br/> <b>Please grant admin rights to at least one other user to complete this action.</b></>
      );
      removeUser.header = "Cannot edit admin rights";
      removeUser.button = "";

      this.setState({ removeUser });
      this.setState({ userDeleteModal: true });
    }
    else {
      this.setState({ removeUser });
      this.setState({ userAdminModal: true });
    }
  }

  setAdmin = (user, action) => {
    const formData = new FormData();
    // action = 'remove-admins' or 'add-admins'
    formData.append(action, user.email);
    formData.append("_method", "PATCH");

    axios
      .patch(
        this.props.baseUrl +
          "/api/api/network/" +
          this.state.network.uuid +
          "/admins/",
        formData,
        {
          headers: this.getHeaders(),
        }
      )
      .then((response) => {
        this.refreshList();
        this.notify_admin();
        this.setState({ validationErrors: [] });
        this.toggleModal("userAdminModal");
      })
      .catch((errors) => {
        this.setState({ validationErrors: errors.response.data });
      });
    return;
  };

  render() {
    return (
      <div className="dashboard">
        <div className="node_table">
          {this.state.loaded ? (
            <>
              <div className="dashboard_title">
                <div className="table_title">
                  <h1>{this.state.network.name}</h1>
                  <a
                    href={
                     this.state.baseDir+"/networks/" + this.state.network.uuid + "/"
                    }
                  >
                    <button className="view_network_button">View Nodes</button>
                  </a>
                </div>
              </div>
              <div className="network_description">
                {this.state.descriptionEditToggle ? (
                  <Form
                    onSubmit={(event) => {
                      event.preventDefault();
                    }}
                  >
                    <FormGroup className="form_group">
                      <Input
                        type="text"
                        name="description"
                        value={this.state.edit_description}
                        onChange={this.handleDescriptionChange}
                        placeholder="Enter network description"
                        maxLength="1000"
                      />
                      <button
                        className="save_button"
                        color="success"
                        onClick={() => {
                          this.editDescription();
                        }}
                      >
                        Save
                      </button>
                    </FormGroup>
                  </Form>
                ) : (
                  <>
                    {this.state.network.description}
                    {this.isAdmin(this.props.user) ? (
                      <div className="toolti">
                        <button
                          onClick={() => {
                            this.setState({
                              edit_description: this.state.network.description,
                            });
                            this.setState({ descriptionEditToggle: true });
                          }}
                          className="description_edit_button"
                        >
                          <EditIcon className="description_edit_icon"></EditIcon>
                        </button>
                        <span className="tooltitext">
                          {"  "}Edit description{"  "}
                        </span>
                      </div>
                    ) : null}
                  </>
                )}
              </div>
              <div className="seletion_area">
                <div className="table_selection">
                  <button
                    selected
                    onClick={() => {
                      this.setState({ view_mode: "users" });
                    }}
                    className={`info_selection_button ${
                      "users" === this.state.view_mode && "selected"
                    }`}
                  >
                    Users
                  </button>

                  <button
                    onClick={() => {
                      this.setState({ view_mode: "organizations" });
                    }}
                    className={`info_selection_button ${
                      "organizations" === this.state.view_mode && "selected"
                    }`}
                  >
                    Organizations
                  </button>
                </div>
                <div className="action_selection">
                  {this.isAdmin(this.props.user) &&
                  this.state.view_mode === "users" ? (
                    <div className="action_buttons">
                      <div className="toolti">
                        <button
                          onClick={() => this.setState({ userAddModal: true })}
                          className="action_button"
                        >
                          Add user
                        </button>
                        <span className="tooltitext">
                          {"  "}Add a new user{"  "}
                        </span>
                      </div>
                      <div className="toolti">
                        <button
                          disabled={this.state.selectedUsers.length === 0}
                          onClick={() => this.removeUserToggle()}
                          className="action_button3"
                        >
                          Remove user
                        </button>
                        {this.state.selectedUsers.length === 0 ? (
                          <span className="tooltitext">
                            {"  "}Select a user to remove from the network{"  "}
                          </span>
                        ) : (
                          <span className="tooltitext">
                            {"  "}Remove user from network{"  "}
                          </span>
                        )}
                      </div>

                      <div className="toolti">
                        <button
                          disabled={this.state.selectedUsers.length !== 1}
                          onClick={() => {
                            this.editAdminToggle()
                          }}
                          className="action_button2"
                        >
                          Admin rights
                        </button>
                        {this.state.selectedUsers.length !== 1 ? (
                          <span className="tooltitext">
                            {"  "}Select a user to edit admin rights{"  "}
                          </span>
                        ) : (
                          <span className="tooltitext">
                            {"  "}Edit user's admin rights{"  "}
                          </span>
                        )}
                      </div>
                    </div>
                  ) : null}
                  {this.isAdmin(this.props.user) &&
                  this.state.view_mode === "organizations" ? (
                    <div className="action_buttons">
                      <div className="toolti">
                        <button
                          onClick={() =>
                            this.setState({ organizationAddModal: true })
                          }
                          className="action_button"
                        >
                          Add Organization
                        </button>
                        <span className="tooltitext">
                          {"  "}Add an organization{"  "}
                        </span>
                      </div>
                      <div className="toolti">
                        <button
                          disabled={
                            this.state.selectedOrganizations.length === 0
                          }
                          onClick={() =>
                            this.setState({ organizationRemoveModal: true })
                          }
                          className="action_button3"
                        >
                          Remove Organization
                        </button>
                        {this.state.selectedUsers.length === 0 ? (
                          <span className="tooltitext">
                            {"  "}Select an organization to remove from network
                            {"  "}
                          </span>
                        ) : (
                          <span className="tooltitext">
                            {"  "}Remove organization from network{"  "}
                          </span>
                        )}
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
              {this.state.view_mode === "users" ? (
                <div className="info_table">
                  <UserTable
                    users={this.state.network.users}
                    admins={this.state.network.admins}
                    setSelection={this.setUser}
                  />
                </div>
              ) : (
                <div className="info_table">
                  <OrganizationTable
                    network={this.state.network}
                    setSelection={this.setOrganization}
                  />
                </div>
              )}
            </>
          ) : null}
        </div>

        {this.state.userAddModal ? (
          <UserAddModal
            toggle={this.toggleModal}
            toggleName="userAddModal"
            getErrors={this.renderErrors}
            onSave={this.addUser}
            users={this.state.network.users}
          />
        ) : null}

        {this.state.userDeleteModal ? (
          <RemoveModal
            toggle={this.toggleModal}
            toggleName="userDeleteModal"
            users={this.state.selectedUsers}
            onSave={this.removeUser}
            message_body={this.state.removeUser.body}
            message_header={this.state.removeUser.header}
            saveButton={this.state.removeUser.button}
          />
        ) : null}

        {this.state.organizationRemoveModal ? (
          <RemoveModal
            toggle={this.toggleModal}
            toggleName="organizationRemoveModal"
            users={this.state.selectedOrganizations}
            onSave={this.removeOrganization}
            message_body={
              "Are you sure you want to remove organization" +
              (this.state.selectedOrganizations.length > 1 ? "s" : "") +
              " " +
              this.getUserStr(
                this.state.selectedOrganizations,
                "organizations"
              ) +
              " from the network?"
            }
            message_header={"Remove organization"}
            saveButton={"Remove"}
          />
        ) : null}
        
        {this.state.failedEditAdminModal ? (
          <RemoveModal
            toggle={this.toggleModal}
            toggleName="failedEditAdminModal"
            users={this.state.selectedUsers}
            onSave={this.removeUser}
            message_body={this.state.removeUser.body}
            message_header={this.state.removeUser.header}
            saveButton={this.state.removeUser.button}
          />
        ) : null}

        {this.state.userAdminModal ? (
          <UserAdminModal
            toggle={this.toggleModal}
            toggleName="userAdminModal"
            users={this.state.selectedUsers}
            onSave={this.setAdmin}
            isAdmin={this.isAdmin(this.state.selectedUsers[0].username)}
          />
        ) : null}

        {this.state.organizationAddModal ? (
          <OrganizationAddModal
            toggle={this.toggleModal}
            toggleName="organizationAddModal"
            onSave={this.addOrganization}
            getErrors={this.renderErrors}
          />
        ) : null}
      </div>
    );
  }

  notify_add = () => {
    store.addNotification({
      title: "Success!",
      type: "success",
      message: "User added to the network",
      insert: "top",
      container: "top-right",
      animationIn: ["animate__animated", "animate__fadeIn"],
      animationOut: ["animate__animated", "animate__fadeOut"],
      dismiss: {
        duration: 5000,
        onScreen: true,
        showIcon: true,
      },
    });
  };

  notify_org_add = () => {
    store.addNotification({
      title: "Success!",
      type: "success",
      message: "Organization added to the network",
      insert: "top",
      container: "top-right",
      animationIn: ["animate__animated", "animate__fadeIn"],
      animationOut: ["animate__animated", "animate__fadeOut"],
      dismiss: {
        duration: 5000,
        onScreen: true,
        showIcon: true,
      },
    });
  };

  notify_delete = () => {
    store.addNotification({
      type: "danger",
      message: "Removed user selection from network",
      insert: "top",
      container: "top-right",
      animationIn: ["animate__animated", "animate__fadeIn"],
      animationOut: ["animate__animated", "animate__fadeOut"],
      dismiss: {
        duration: 5000,
        onScreen: true,
        showIcon: true,
      },
    });
  };

  notify_org_delete = (username) => {
    store.addNotification({
      type: "danger",
      message: "Removed organization selection from network",
      insert: "top",
      container: "top-right",
      animationIn: ["animate__animated", "animate__fadeIn"],
      animationOut: ["animate__animated", "animate__fadeOut"],
      dismiss: {
        duration: 5000,
        onScreen: true,
        showIcon: true,
      },
    });
  };

  notify_admin = () => {
    store.addNotification({
      type: "info",
      message: "User's admin rights updated",
      insert: "top",
      container: "top-right",
      animationIn: ["animate__animated", "animate__fadeIn"],
      animationOut: ["animate__animated", "animate__fadeOut"],
      dismiss: {
        duration: 5000,
        onScreen: true,
        showIcon: true,
      },
    });
  };
}

export default withRouter(NetworkInfo);
